const mutations = {
    DRAW_LOADING: (state) => {
        // state.drawStatus = 'loading';
        Vue.set(state, 'drawStatus', 'loading');
    },
    SEASONS_SUCCESS: (state, data) => {
        state.drawStatus = 'success';
        Vue.set(state, 'seasons', data);
    },
    DIVISIONS_SUCCESS: (state, data) => {
        state.drawStatus = 'success';
        Vue.set(state, 'divisions', data);
        Vue.set(state, 'draw', []);
        Vue.set(state, 'teams', []);
    },
    TEAMS_SUCCESS: (state, data) => {
        state.drawStatus = 'success';
        Vue.set(state, 'teams', data);
    },
    DRAW_SUCCESS: (state, data) => {
        state.drawStatus = 'success';
        Vue.set(state, 'draw', data);
    },
    RESULT_SUCCESS: (state, data) => {
        state.drawStatus = 'success';
        Vue.set(state, 'result', data);
    },
    DRAW_ERROR: (state, err) => {
        let errors=err.error?err.error:{};

        state.drawStatus = 'error';
        state.drawErrors.record(errors);
    },
    CLEAR_DRAW_ERRORS: (state) => {
        state.drawStatus = '';
        state.drawErrors.clear();
    },
    RESET_STATE: (state) => {
        Object.assign(state, state.initialState());
    }
}

export default mutations
